var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content_copy 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33341 0.666626H13.3334C14.0667 0.666626 14.6667 1.26663 14.6667 1.99996V11.3333H13.3334V1.99996H5.33341V0.666626ZM3.33341 3.33329H10.6667C11.4001 3.33329 12.0001 3.93329 12.0001 4.66663V14C12.0001 14.7333 11.4001 15.3333 10.6667 15.3333H3.33341C2.60008 15.3333 2.00008 14.7333 2.00008 14V4.66663C2.00008 3.93329 2.60008 3.33329 3.33341 3.33329ZM3.33341 14H10.6667V4.66663H3.33341V14Z",
    fill: "#7A7A7B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedCopy);
export default __webpack_public_path__ + "static/media/completed-copy.c1dd3037c0456f41eca5f875273342b9.svg";
export { ForwardRef as ReactComponent };